module.exports = __webpack_public_path__ + "static/media/bubble-msg-02.32127d82.png";